import React, { Fragment }  from 'react';
import { Header,  Form, Label } from 'semantic-ui-react';
import yup from 'yup';
import Field from '../Field';
import VerificationFormField from '../VerificationFormField'
import withVericationForm from './withVericationForm'
import FlightDate from '../FlightDate'

const ERROR_REQUIRED = 'This field is required'

class BoardingPassEquivalentForm extends React.PureComponent {

  _onChange = (e, {name, value} ) => this.props.onChange(this.props.documentId, name, value)

  render = () => {
    const {
      onBlur,
      values,
      errors,
      touched
    } = this.props;
    return (
      <Fragment>
        <Header>
          Boarding pass equivalent
        </Header>
        <Form>
          <Field
            error={errors.validNameOfPax}
            touched={touched.validNameOfPax}
          >
            <VerificationFormField
              name="validNameOfPax"
              value={values.validNameOfPax}
              onChange={this._onChange}
              onBlur={onBlur.bind(this, 'validNameOfPax')}>

              <p>Passenger name is </p>
              <Label>{this.passengerName()}</Label>

            </VerificationFormField>
          </Field>
          <Field
            error={errors.validFlightNumber}
            touched={touched.validFlightNumber}
          >
            <VerificationFormField
              name="validFlightNumber"
              value={values.validFlightNumber}
              onChange={this._onChange}
              onBlur={onBlur.bind(this, 'validFlightNumber')}>

              <p>Flight number is </p>
              <Label>{this.flightNumber()}</Label>

            </VerificationFormField>
          </Field>
          <Field
            error={errors.validDepartureDatetime}
            touched={touched.validDepartureDatetime}
          >
            <VerificationFormField
              name="validDepartureDatetime"
              value={values.validDepartureDatetime}
              onChange={this._onChange}
              onBlur={onBlur.bind(this, 'validDepartureDatetime')}>

              <p>Departure date is </p>
              <Label>{this.departureDate()}</Label>

            </VerificationFormField>
          </Field>
          <Field
            error={errors.validOperatingAirline}
            touched={touched.validOperatingAirline}
          >
            <VerificationFormField
              name="validOperatingAirline"
              value={values.validOperatingAirline}
              onChange={this._onChange}
              onBlur={onBlur.bind(this, 'validOperatingAirline')}>

              <p>Airline is </p>
              <Label>{this.airline()}</Label>

            </VerificationFormField>
          </Field>
        </Form>
      </Fragment>
    )
  }
  passengerName(){
    const passengerTicket = this.props.passengerTicket
    if(!passengerTicket){
      return ''
    }
    return [
      passengerTicket.passengerFirstName,
      passengerTicket.passengerLastName].join(' ')
  }
  flight(){
    const claim = this.props.claim
    if(!claim){
      return undefined
    }
    return claim.flight
  }
  flightNumber(){
    const flight = this.props.flight
    if(!flight){
      return ''
    }
    return flight.airline.iata + flight.number
  }
  airline(){
    const flight = this.props.flight
    if(!flight){
      return ''
    }
    return flight.airline.name
  }
  departureDate(){
    const flight = this.props.flight
    if(!flight){
      return ''
    }
    return <FlightDate date={flight.localDepartureDate}/>
  }

}

const formikConfig = {
  mapPropsToValues: props => {
    return {...props.formValues}
  },
  validationSchema: () => {
    return yup.object().shape({
      validFlightNumber: yup.boolean().required(ERROR_REQUIRED),
      validOperatingAirline: yup.boolean().required(ERROR_REQUIRED),
      validNameOfPax: yup.boolean().required(ERROR_REQUIRED),
      validDepartureDatetime: yup.boolean().required(ERROR_REQUIRED)
    })
  }
}

export default withVericationForm(formikConfig, ['validNameOfPax', 'validFlightNumber', 'validDepartureDatetime', 'validOperatingAirline'])(BoardingPassEquivalentForm)



// WEBPACK FOOTER //
// ./src/component/verification_forms/BoardingPassEquivalentForm.js